module.exports = __webpack_public_path__ + "static/media/b0_p5_melody.402afc8d.mp3";